/**
 * @description String capitalize first letter - 'TEXT' => 'Text'
 * @returns Txt
 */
export const capitalize = txt => txt.charAt(0).toUpperCase() + txt.toLowerCase().substr(1);

export const percentageToNumber = (value: string): Number => {
  const num = value.replace('%', '');
  return Number(num) / 100;
};

export const toElapsedTime_UserManagement = (date: Date) => {
  const day = parseInt(date.toString().substring(0, 2), 10);
  const month = parseInt(date.toString().substring(3, 5), 10);
  const year = parseInt(date.toString().substring(6, 11), 10);
  const hour = parseInt(date.toString().substring(11, 13), 10);
  const min = parseInt(date.toString().substring(14, 16), 10);
  const sec = parseInt(date.toString().substring(17, 19), 10);
  const createdDate = new Date(year, month - 1, day, hour, min, sec); // Month is 0-11 in JavaScript
  const today = new Date();
  const diff = new Date(today.getTime() - createdDate.getTime());

  const dateMeasure = ms => {
    let d, h, m, s;
    s = Math.floor(ms / 1000);
    m = Math.floor(s / 60);
    s = s % 60;
    h = Math.floor(m / 60);
    m = m % 60;
    d = Math.floor(h / 24);
    h = h % 24;

    if (d > 2) {
      return `${Math.floor(d)}d ago`;
    }
    if (d > 1) {
      return `${d + Math.round((h / 24) * 10) / 10}d ago`;
    }
    if (h > 0) {
      return `${h + Math.round((m / 60) * 10) / 10}h ago`;
    }
    if (m > 0) {
      return `${m + Math.round((s / 60) * 10) / 10}m ago`;
    }
    return `${s}s ago`;
  };

  const retString = dateMeasure(diff.getTime());
  return retString;
};

export const toElapsedTime = secs => {
  const origSecs = secs;
  let d = 0,
    h = 0,
    m = 0,
    s = 0,
    ret = '';

  while (secs > 86400) {
    // 1d
    d++;
    secs -= 86400;
  }
  while (secs > 3600) {
    // 1h
    h++;
    secs -= 3600;
  }
  while (secs > 60) {
    // 1m
    m++;
    secs -= 60;
  }
  s = secs;

  if (d > 0) {
    ret += `${d}d `;
  }
  if (h > 0) {
    ret += `${h}h `;
  }
  if (m > 0) {
    ret += `${m}m `;
  }
  if (s > 0) {
    ret += `${s}s `;
  }
  ret = ret.trim();

  // colorLog(`Secs: ${origSecs}, Ret: ${ret === '' ? 'current' : ret}`, 'info');
  return `${ret}`;
};

export const isPercentage = (perc: string) =>
  perc
    .toString()
    .trim()
    .match(/^(\d+(?:\.\d+)?|[-]\s?\d+(?:\.\d+)?)\s*[%]$/);
